<template>
	<div class="business">
		<div class="business-body">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline-message='true' label-position='right' label-width="100px" class="box">
				<div class="fx-title">基础信息</div>
				<div class="basic-info-wrap">
					<div class="basic-info-left">
						<el-form-item label="员工编号:">
							<span>{{ruleForm.code}}</span>
						</el-form-item>
						<el-form-item label="员工姓名:" prop='name'>
							<el-input :disabled="adminDisable" class='input-box' v-model="ruleForm.name" :maxlength='10' size='mini' @blur="nameChange"></el-input>
						</el-form-item>
						<el-form-item label="登录密码:" prop='pass'>
							<el-input :disabled="!modifyDisable" @focus="psdFocus" autocomplete="new-password" type="password" size='mini' class='input-box' placeholder="填写6-20位字母和数字组合的密码" v-model="ruleForm.pass"></el-input>
						</el-form-item>
						<el-form-item label="确认密码:" prop='checkPass'>
							<el-input :disabled="!modifyDisable" @focus="checkFocus" autocomplete="new-password" type="password" size='mini' class='input-box' v-model="ruleForm.checkPass"></el-input>
						</el-form-item>
						<el-form-item label="手机号:" prop='phone'>
							<el-input :disabled="adminDisable" class='input-box' @blur='checkPhone' size='mini' v-model="ruleForm.phone" :maxlength='11' onkeyup="value=value.replace(/[^0-9]/g,'')" onpaste="value=value.replace(/[^0-9]/g,'')" oncontextmenu="value=value.replace(/[^0-9]/g,'')"></el-input>
						</el-form-item>
						<el-form-item v-if="!isAdmin" label="员工类型:" prop="status">
							<el-radio-group size='mini' v-model="ruleForm.usertype">
								<el-radio :disabled="adminDisable" :label="0">内控</el-radio>
								<el-radio :disabled="adminDisable" :label="1">业务</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="员工角色:">
							<div v-if="ruleForm.role && isAdmin">{{ruleForm.role}}</div>
							<el-select v-model="staffRole" placeholder="请选择员工角色" class="name-input" multiple collapse-tags filterable size='mini' v-else>
								<el-option v-for="(item,index) in roleTableData" :key='index' :value="item.id" :label="item.name"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="员工状态:" prop="status">
							<el-radio-group size='mini' v-model="ruleForm.status">
								<el-radio :disabled="adminDisable" :label="0">启用</el-radio>
								<el-radio :disabled="adminDisable" :label="1">停用</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item v-if="!isAdmin" label="自动打印:" prop="status">
							<el-radio-group size='mini' v-model="ruleForm.autoprint" @change="autoprintChange">
								<el-radio :disabled="adminDisable" :label="1">启用</el-radio>
								<el-radio :disabled="adminDisable" :label="0">停用</el-radio>
							</el-radio-group>
							<el-select size="mini" :disabled="adminDisable" v-model="ruleForm.printname" class="select-box" style="margin-left:10px;width:170px" v-show="ruleForm.autoprint === 1">
								<el-option
									v-for="item in printerOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<div style="color:red;line-height: 10px;" v-show="autoprintFlag === 0">*系统设置已关闭自动打印，该员工无法自动打印！</div>
						</el-form-item>
						<el-form-item label="接收消息:" prop="subscriptionSendFlag">
							<el-radio-group size='mini' @change="subscriptionSendFlagChange" v-model="ruleForm.subscriptionSendFlag" :disabled="isAdd">
								<el-radio :disabled="!modifyDisable" :label="false">不接收</el-radio>
								<el-radio :disabled="!modifyDisable" :label="true">接收</el-radio>
							</el-radio-group>
						</el-form-item>
						<div v-if="ruleForm.subscriptionSendFlag" style="display: flex;flex-direction: row;">
							<div class="code-box">
								<w-image v-if="codeImg !== ''" style="width: 100%;height: 100%;" :src="codeImg"></w-image>
								<img v-if="codeImg === '' && follow" style="width: 100%;height: 100%;" src='~/images/icon/fakecode.png' />
								<div class="no-follow" v-if="showMask">
									<el-button v-if="!follow && !isTimeOut" type="primary" size="mini" @click="getImg('ruleForm')">生成二维码</el-button>
									<el-button v-if="follow && !isTimeOut" type="primary" size="mini" @click="getImg('ruleForm')">重新绑定</el-button>
									<el-button v-if="isTimeOut" type="primary" size="mini" @click="getImg('ruleForm')">刷新</el-button>
								</div>
							</div>
							<div class="tip-box">
								<div>说明：微信扫码绑定后，通过极速订公众号接收消息通知</div>
								<!-- <div style="margin-top: 20px;">绑定微信名字：{{ruleForm.subscriptionNickName}}</div> -->
							</div>
						</div>
						<div class="time-tip" v-if="showtime">{{time}}秒后失效</div>
						<div style="text-align: left;">
							<span style="color: #F56C6C;">*</span> 员工是否可以帮客户支付:
							<el-radio-group size='mini' v-model="ruleForm.payForCustomerFlag">
								<el-radio :disabled="!modifyDisable" :label="0">否</el-radio>
								<el-radio :disabled="!modifyDisable" :label="1">是</el-radio>
							</el-radio-group>
							<el-tooltip class="item" effect="dark" content="选择'是',员工可帮助客户未付款订单进行支付,请谨慎操作" placement="top">
								<i class="el-icon-info" style="margin-left: 10px;color: var(--fx-primary-color);"></i>
							</el-tooltip>
						</div>
					</div>
					<div v-if="showPromotionCode && !!staffImgUrl" class="business-picture">
						<div class="distribution-code-title">分销码</div>
						<div class="distribution-code-img">
							<w-image :src="staffImgUrl" class="staff-avatar-img"></w-image>
						</div>
						<div class="distribution-code-download" @click="downloadStaffImg">下载图片</div>
					</div>
				</div>
				<div v-if="shopList.length > 1">
					<div class="fx-title">适用门店</div>
					<el-form-item label="适用门店:" prop="status">
						<el-radio-group size='mini' v-model="ruleForm.shopattendway">
							<el-radio :label="0">自定义门店</el-radio>
							<el-radio :label="1">全部门店</el-radio>
							<span v-if="ruleForm.shopattendway === 0" @click="bindShopClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
								<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
								选择门店
							</span>
						</el-radio-group>
					</el-form-item>
				</div>
				<el-form-item v-if="(ruleForm.shopattendway === 1 || (ruleForm.shopattendway === 0 && shopText)) && shopList.length > 1" label="已选：" size='mini'>
					<span>{{ruleForm.shopattendway === 1 ? '全部门店' : shopText}}</span>
				</el-form-item>
				<div class="fx-title">个人信息</div>
				<el-form-item label="身份证号:" prop='identitycardno'>
					<el-input class='input-box' v-model="ruleForm.identitycardno" :maxlength='200' size='mini'></el-input>
				</el-form-item>
				<el-form-item label="银行卡号:" prop='bankcardno'>
					<el-input class='input-box' v-model="ruleForm.bankcardno" :maxlength='200' size='mini'></el-input>
				</el-form-item>
				<el-form-item label="开户银行:" prop='bankName'>
					<el-input class='input-box' v-model="ruleForm.bankName" :maxlength='200' size='mini'></el-input>
				</el-form-item>
				<el-form-item label="账户名:" prop='bankAccount'>
					<el-input class='input-box' v-model="ruleForm.bankAccount" :maxlength='200' size='mini'></el-input>
				</el-form-item>
				<el-form-item label="住址:" prop='addr'>
					<el-input class='input-box' v-model="ruleForm.addr" :maxlength='200' size='mini'></el-input>
				</el-form-item>
				<el-form-item label="备注:" prop='remark'>
					<el-input class='input-box' v-model="ruleForm.remark" :maxlength='200' size='mini'></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="business-foot"  v-if="modifyDisable">
			<el-button class="btn" plain type="primary" size='small' @click="resetForm('ruleForm')">取消</el-button>
			<el-button class="btn" plain type="primary" size='small' @click="submitForm('ruleForm')">确认</el-button>
		</div>
		<el-dialog top='60px' class="subordinateDialog" :close-on-click-modal="false" :append-to-body="true" :visible.sync="showSubordinate" width='800px'>
			<div class="title">
				<div style="display: flex;flex-direction: row;align-items: center;">
					<div class="blue-line"></div>
					{{ruleForm.name}}可管理下属员工 <span style="color: red;font-size: 14px;margin-left: 10px;">(共{{staffNum}}人)</span>
				</div>
				<span class="close" @click='closeClick'>
					<i class="el-icon-close"></i>
				</span>
			</div>
			<div class="type-box">
				<el-radio @change='reloadTableData' v-model="type" :label="1">可管理</el-radio>
				<el-radio @change='reloadTableData' v-model="type" :label="0">未管理</el-radio>
			</div>
			<div class="input-box">
				<span>员工名称：</span>
				<el-input
					v-model="userName"
					placeholder="请输入员工名称/员工编号"
					class="name-input"
					size="mini"
					@keyup.enter.native="reloadTableData"
					>
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<el-button size='mini' type="primary" @click='reloadTableData'>查看</el-button>
			</div>
			<div style="height: 300px;margin-top: 10px;">
				<el-table
				:stripe='true'
				ref='table1'
				size='mini'
				class="grid-content"
				:data="tableData1"
				:height="tableHeight"
				border
				@selection-change="handleSelectionChange1">
				<el-table-column
				type="selection"
				align="center"
				:selectable='selectable1'
				width="50">
				</el-table-column>
				<el-table-column
					prop="userName"
					label="员工名称"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="userNumber"
					label="员工编号"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					prop="roleName"
					label="员工角色"
					align="center"
					min-width="100">
					<template slot-scope="scope">
						<span v-if='scope.row.roleCount > 1'>多角色</span>
						<span v-else>{{scope.row.roleName}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="disabledFlag"
					label="员工状态"
					align="center"
					min-width="90">
					<template slot-scope='scope'>
						<div style="display: flex;flex-direction: row;align-items: center;justify-content: center">
							<div v-if='!scope.row.disabledFlag'  style="width: 5px;height: 5px;margin-right: 5px;border-radius: 50%;background-color: #60C769;"></div>
							<div v-if='scope.row.disabledFlag'  style="width: 5px;height: 5px;margin-right: 5px;border-radius: 50%;background-color: #727A83;"></div>
							<span v-if='!scope.row.disabledFlag' style="color:#333333">启用</span>
							<span v-if='scope.row.disabledFlag' style="color:#727A83">停用</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					v-if="type === 0"
					prop="leaderFlag"
					label="上下级关系"
					align="center"
					min-width="100">
					<template slot-scope='scope'>
						<span v-if='scope.row.leaderFlag === 1'>上级</span>
						<span v-else>下级</span>
					</template>
				</el-table-column>
				</el-table>
			</div>
			<div style="width: 100%;height: 60px;margin-bottom: 10px;display: flex;align-items: center;justify-content: flex-end;">
				<el-button @click='closeClick' size='mini'>取消</el-button>
				<el-button @click='bindClick' v-if="type === 0 && AuthorityList['01_0004_0001_00']" size='mini' type="primary">绑定</el-button>
				<el-button  @click='unBindClick' v-if="type === 1 && AuthorityList['01_0004_0001_00']"  size='mini' type="primary">解绑</el-button>
			</div>
		</el-dialog>
		<el-dialog title='客户管理' top='60px' class="customerDialog" :close-on-click-modal="false" :append-to-body="true" :visible.sync="customerDialog" width='800px'>
			<bindCustomer
				v-if='customerDialog'
				:customerDialog.sync="customerDialog"
				:isEdit="AuthorityList['01_0004_0001_00']"
				:staffId='ruleForm.id'
				@closepage='closeCustomer'
			>
			</bindCustomer>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			:append-to-body="true"
			width="780px"
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import bindCustomer from '@/components/personnelManage/bindCustomer.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
const psd = '······'
export default {
	name: 'business',
	components: {
		bindCustomer, bindShop
	},
	props: {
		modifyData: Object,
		id: String,
		// isAdd: Boolean,
		addDisable: Boolean,
		isDisabled: Boolean,
		AuthorityList: Object
	},
	data () {
		var phone = (rule, value, callback) => {
			if (this.phoneWaring === '1') {
				return callback(new Error('请输入正确手机号'))
			} else if (this.phoneWaring === '2') {
				return callback(new Error('手机号重复'))
			} else {
				callback()
			}
		}
		var validatePass = (rule, value, callback) => {
			if (this.isAdd === true) {
				if (value === '') {
					callback(new Error('请输入密码'))
				} else {
					if (psd === this.ruleForm.pass) {
						callback()
					} else {
						var reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/
						if (!(reg.test(value))) {
							callback(new Error('请输入正确密码'))
						} else {
							callback()
							this.$refs.ruleForm.validateField('checkPass')
						}
					}
				}
			} else {
				if (psd === this.ruleForm.pass) {
					callback()
				} else {
					if (value === '') {
						callback(new Error('请输入密码'))
					} else {
						var reg1 = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/
						if (!(reg1.test(value))) {
							callback(new Error('请输入正确密码'))
						} else {
							callback()
							this.$refs.ruleForm.validateField('checkPass')
						}
					}
				}
			}
		}
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			showtime: false,
			timer: null,
			showMask: true,
			follow: false,
			codeImg: '',
			data: {},
			addFlag: false,
			modifyDisable: false,
			adminDisable: false,
			isAdmin: false,
			phoneWaring: null,
			isWaring: false,
			showSubordinate: false,
			customerDialog: false,
			shopDialog: false,
			tableHeight: '100%',
			ruleForm: {
				subscriptionAppId: '',
				subscriptionOpenId: '',
				subscriptionNickName: '',
				subscriptionSendFlag: false,
				id: '',
				role: '',
				name: '',
				phone: '',
				pass: '',
				status: 0,
				usertype: 0,
				payForCustomerFlag: 0,
				checkPass: '',
				addr: '',
				remark: '',
				bankcardno: '',
				identitycardno: '',
				autoprint: 0,
				printname: '',
				bankName: '',
				bankAccount: '',
				shopattendway: 0,
				staffattendway: 1,
				customattendway: 0
			},
			rules: {
				name: [
					{ required: true, message: '请输入员工名称', trigger: 'blur' }
				],
				pass: [
					{ required: true, validator: validatePass, trigger: 'blur' }
				],
				checkPass: [
					{ required: true, validator: validatePass2, trigger: 'blur' }
				],
				status: [
					{ required: true, message: '请选择员工状态', trigger: 'change' }
				],
				print: [
					{ required: true, message: '请选择自动打印状态', trigger: 'change' }
				],
				phone: [
					{ required: true, validator: phone, trigger: 'blur' }
				],
				subscriptionSendFlag: [
					{ required: true, trigger: 'blur' }
				]
			},
			staffRole: [],
			roleTableData: [],
			isAdd: false,
			ticket: '',
			time: 60,
			isTimeOut: false,
			printerOptions: [],
			autoprintFlag: 1,
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			shopText: '',
			staffText: '',
			customText: '',
			userName: '',
			tableData1: [],
			staffNum: 0,
			type: 0,
			selectData: [],
			chooseShop: [],
			shopList: [],
			staffImgUrl: ''
		}
	},
	computed: {
		showPromotionCode () {
			const syscode = window.sessionStorage.getItem('syscode')
			return ['570', '674820', '119916', '985040', '9153'].includes(syscode)
		}
	},
	watch: {
		isAdd: {
			handler (val) {
				this.modifyDisable = this.isDisabled
				if (val === true) {
					if (this.id !== null) {
						this.getData()
					}
					// this.RoleReload()
					if (this.addDisable) {
						this.modifyDisable = true
						this.adminDisable = false
					}
					this.follow = false
					this.showMask = true
					this.staffImgUrl = ''
					this.ruleForm = {
						id: '',
						role: '',
						name: '',
						pass: '',
						addr: '',
						phone: '',
						status: 0,
						remark: '',
						bankName: '',
						bankAccount: '',
						usertype: 0,
						payForCustomerFlag: 0,
						checkPass: '',
						autoprint: 0,
						printname: '',
						bankcardno: '',
						identitycardno: '',
						subscriptionAppId: '',
						subscriptionOpenId: '',
						subscriptionNickName: '',
						subscriptionSendFlag: false,
						shopattendway: 1,
						staffattendway: 1,
						customattendway: 1
					}
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.addFlag = false
				}
			},
			immediate: true
		},
		modifyData: {
			handler (val) {
				if (this.isAdd === false && val !== null) {
					if (val && val.isAdmin === 1) {
						this.isAdmin = true
					} else {
						this.isAdmin = false
					}
					if (this.isAdmin || !this.isDisabled) {
						this.adminDisable = true
					} else {
						this.adminDisable = false
					}
					this.ruleForm.phone = val.tel
					this.ruleForm.id = val.staffid
					this.ruleForm.code = val.staffNumber
					this.ruleForm.name = val.staffName
					this.ruleForm.pass = psd
					this.ruleForm.usertype = val.usertype
					this.ruleForm.payForCustomerFlag = val.payForCustomerFlag
					this.ruleForm.checkPass = psd
					this.ruleForm.autoprint = val.autoprint
					this.ruleForm.printname = val.printname
					this.getDetail(this.ruleForm.id).then(() => {
						if (val.staffDisabled === false) {
							this.ruleForm.status = 0
						} else {
							this.ruleForm.status = 1
						}
						this.getRole(val.staffid).then(() => {
							this.fxDataVerification.resetData(this.ruleForm)
						})
						this.fxDataVerification.resetData(this.ruleForm)
					})
				}
			},
			immediate: true
		}
	},
	created () {
		this.isAdd = JSON.parse(window.sessionStorage.getItem('isAdd'))
		this.findall()
		this.getShop()
		this.RoleReload()
	},
	mounted () {
	},
	methods: {
		psdFocus () {
			this.ruleForm.pass = ''
		},
		checkFocus () {
			this.ruleForm.checkPass = ''
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			}).catch(() => {
			})
		},
		// 打印相关js文件均在public文件夹下index.html文件引入
		deviceInit () {
			let _this = this
			if (navigator.userAgent.indexOf('Windows') < 0) {
				this.$message.error('请在 Windows 系统中使用自定义打印！')
				return false
			}
			// 初始化打印
			/* eslint-disable-next-line */
			TDevices.init().then(() => {
				// 获取打印机
				_this.getPrinter()
				// 获取模板
				_this.getTemplate()
			})
		},
		getPrinter () {
			let _this = this
			// 实例化一个打印机相关的对象，获取打印机列表
			/* eslint-disable-next-line */
			let report = new FastReport()
			report.enable = true
			report.printerlist(function (result) {
				var printerList = result.message.list
				printerList.forEach(item => {
					_this.printerOptions.push({
						value: item,
						label: item
					})
				})
				_this.printerValue = _this.printerOptions[0].value
			})
		},
		findall () {
			let formData = new FormData()
			formData.append('shopid', sessionStorage.getItem('storeid'))
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findall`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.autoprintFlag = res.data.autoprintflag
					if (this.isAdd) {
						this.ruleForm.autoprint = res.data.autoprintflag
						this.ruleForm.printname = res.data.printname
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		subscriptionSendFlagChange () {
			if (!this.ruleForm.subscriptionSendFlag) {
				this.showMask = true
				this.showtime = false
				clearInterval(this.timer)
				this.timer = null
			}
		},
		autoprintChange () {
			if (this.ruleForm.autoprint) {
				this.deviceInit()
			}
		},
		check () {
			this.time = this.time - 1
			if (this.time < 0) {
				this.showMask = true
				this.showtime = false
				this.isTimeOut = true
				clearInterval(this.timer)
				return false
			}
			let params = {
				ticket: this.ticket
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/staff/wechatnickname/`,
				loading: false,
				data: params
			}).then(res => {
				if (res.result) {
					this.showtime = false
					this.ruleForm.subscriptionAppId = res.data.subscriptionAppId
					this.ruleForm.subscriptionNickName = res.data.subscriptionNickName
					this.ruleForm.subscriptionOpenId = res.data.subscriptionOpenId
					clearInterval(this.timer)
				}
			}).catch(() => {
				clearInterval(this.timer)
			})
		},
		loop () {
			this.timer = setTimeout(() => {
				this.check()
				this.loop()
			}, 1000)
		},
		getDetail (id) {
			let params = {
				staffId: id
			}
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/staff/detail/`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					this.data = data
					this.staffImgUrl = ''
					if (this.showPromotionCode) {
						this.getStaffPromotionCode(id)
					}
					this.modifyData.tel = data.tel
					this.ruleForm.phone = data.tel
					this.ruleForm.subscriptionAppId = data.subscriptionAppId
					this.ruleForm.payForCustomerFlag = data.payForCustomerFlag
					if (data.subscriptionOpenId) {
						this.ruleForm.subscriptionOpenId = data.subscriptionOpenId
					}
					this.ruleForm.subscriptionNickName = data.subscriptionNickName
					this.ruleForm.subscriptionSendFlag = data.subscriptionSendFlag
					this.ruleForm.addr = data.addr ? data.addr.replace(/[\r\n\t\\\']/g, '') : ''
					this.ruleForm.bankName = data.bankname ? data.bankname.replace(/[\r\n\t\\\']/g, '') : ''
					this.ruleForm.bankAccount = data.bankaccount ? data.bankaccount.replace(/[\r\n\t\\\']/g, '') : ''
					this.ruleForm.bankcardno = data.bankcardno ? data.bankcardno.replace(/[\r\n\t\\\']/g, '') : ''
					this.ruleForm.identitycardno = data.identitycardno ? data.identitycardno.replace(/[\r\n\t\\\']/g, '') : ''
					this.ruleForm.remark = data.remark ? data.remark.replace(/[\r\n\t\\\']/g, '') : ''
					this.ruleForm.autoprint = data.autoprintflag
					if (this.ruleForm.autoprint) {
						this.deviceInit()
					}
					this.ruleForm.printname = data.printname
					this.ruleForm.shopattendway = data.relAllShopFlag
					this.shopText = data.shops.map(e => {
						return e.shopname
					}).join(',')
					this.chooseShop = data.shops.map(e => {
						return e.shopid
					})
					// this.ruleForm.customattendway = data.categoryFlag
					this.showMask = true
					if (data.subscriptionNickName === '') {
						this.follow = false
					} else {
						this.follow = true
					}
					return Promise.resolve()
				}
			})
		},
		getStaffPromotionCode (userId) {
			if (!this.showPromotionCode || !userId) {
				this.staffImgUrl = ''
				return Promise.resolve()
			}
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.snvUrl}shop/account/staff/promotion/code?userId=${userId}`,
				loading: false
			}).then(res => {
				if (res.result && res.data) {
					this.staffImgUrl = res.data
				} else {
					this.staffImgUrl = ''
					if (res.msg) {
						this.$message.error(res.msg)
					}
				}
			}).catch(() => {
				this.staffImgUrl = ''
			})
		},
		getImg (formName) {
			if (this.isAdd === true && !this.addFlag) {
				this.checkPhone()
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let params = {
							staffName: this.ruleForm.name,
							tel: this.ruleForm.phone,
							usertype: this.ruleForm.usertype,
							staffDisabled: this.ruleForm.status,
							roleIds: this.staffRole,
							subscriptionSendFlag: this.ruleForm.subscriptionSendFlag
						}
						if (psd !== this.ruleForm.pass) {
							params.password = this.ruleForm.pass
						}
						this.$store.dispatch('requestPost', {
							url: `${this.$fxBaseApi.urlIV}/account/staff/add`,
							data: params
						}).then(res => {
							if (res.result === true) {
								this.addFlag = true
								this.isAdd = false
								this.$nextTick(() => {
									this.getTicket(res.data.data)
								})
							} else {
								this.$message.error(res.msg)
							}
						})
					}
				})
			} else {
				this.getTicket(this.ruleForm.id)
			}
		},
		getTicket (id) {
			clearInterval(this.timer)
			this.timer = null
			let base = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket='
			let params = {
				staffId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/staff/ticket/`,
				data: params
			}).then(res => {
				this.ticket = res.data
				this.codeImg = base + res.data
				this.ruleForm.subscriptionOpenId = ''
				this.isTimeOut = false
				this.showMask = false
				this.showtime = true
				this.time = 60
				this.loop()
			})
		},
		nameChange () {
			var reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g
			var res = this.ruleForm.name.replace(reg, '')
			this.ruleForm.name = res
		},
		getData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/staff/detail/` + this.id
			}).then(res => {
				if (res.result === true) {
					this.addFlag = true
					this.data = res.data
					let val = res.data
					this.ruleForm.phone = val.tel
					this.ruleForm.id = val.staffid
					this.ruleForm.code = val.staffNumber
					this.ruleForm.name = val.staffName
					this.ruleForm.pass = psd
					this.ruleForm.usertype = val.usertype
					this.ruleForm.payForCustomerFlag = val.payForCustomerFlag
					this.ruleForm.checkPass = psd
					this.ruleForm.addr = val.addr
					this.ruleForm.bankName = val.bankName
					this.ruleForm.bankAccount = val.bankAccount
					this.ruleForm.remark = val.remark
					this.ruleForm.bankcardno = val.bankcardno
					this.ruleForm.identitycardno = val.identitycardno
					if (val.staffDisabled === false) {
						this.ruleForm.status = 0
					} else {
						this.ruleForm.status = 1
					}
					this.getRole(val.staffid)
					// if (val.roleCount > 1) {
					// 	this.getRole(val.staffid)
					// } else {
					// 	this.ruleForm.role = val.roleName
					// }
				} else {
					this.message.error(res.msg)
				}
			})
		},
		getRole (id) {
			let params = {
				loginId: id
			}
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/authority/getUserRoles`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					let b = []
					let c = []
					for (let i = 0; i < a.length; i++) {
						b.push(a[i].roleName)
						c.push(a[i].roleid)
					}
					this.ruleForm.role = b.join('/')
					this.staffRole = c
					return Promise.resolve()
				} else {
					this.message.error(res.msg)
				}
			})
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			// console.log(data)
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		closeCustomer () {
			this.customerDialog = false
			// this.tableReload()
		},
		closeClick () {
			this.showSubordinate = false
			// this.tableReload()
		},
		bindClick () {
			if (this.selectData.length === 0) {
				this.$message.error('请勾选员工！')
				return false
			}
			let ids = []
			this.selectData.forEach(item => {
				ids.push(item.userId)
			})
			let params = {
				directlyStaffManagerIds: ids,
				staffId: this.ruleForm.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/bindLeaderForUser`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('绑定成功！')
					this.reloadTableData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		unBindClick () {
			if (this.selectData.length === 0) {
				this.$message.error('请勾选员工！')
				return false
			}
			let ids = []
			this.selectData.forEach(item => {
				ids.push(item.directlyStaffManagerId)
			})
			let params = {
				directlyStaffManagerIds: ids,
				staffId: this.ruleForm.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/unBindLeaderForUser`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('解绑成功！')
					this.reloadTableData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 多选状态禁用
		selectable1 (row, index) {
			if (this.type === 0) {
				if (row.leaderFlag === 1) {
					return false
				} else {
					return true
				}
			} else {
				if (row.directlyFlag === 1) {
					return true
				} else {
					return false
				}
			}
		},
		bindCustomClick () {
			this.customerDialog = true
		},
		bindStaffClick () {
			this.showSubordinate = true
			this.userName = ''
			this.type = 1
			this.getBindList()
		},
		handleSelectionChange1 (data) {
			this.selectData = data
		},
		reloadTableData () {
			if (this.type === 1) {
				this.getBindList()
			} else {
				this.getUnBindList()
			}
		},
		getBindList () {
			let params = {
				userName: this.userName,
				staffId: this.ruleForm.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/findManageredUserInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData1 = res.data.userInfo
					this.$refs.table1.doLayout()
					this.staffNum = res.data.canManagerUserCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getUnBindList () {
			let params = {
				userName: this.userName,
				staffId: this.ruleForm.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/findUnManagerUserInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData1 = res.data.userInfo
					this.$refs.table1.doLayout()
					this.staffNum = res.data.canManagerUserCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		RoleReload () {
			let params = {
				rInfo: '',
				rtype: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getRole`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.roleTableData = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		rulePhone () {
			this.$refs['ruleForm'].validateField('phone', (error) => {
				if (!error) {
					console.log('OK')
				} else {
					return false
				}
			})
		},
		checkPhone () {
			var value = this.ruleForm.phone
			var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!(reg.test(value))) {
				this.phoneWaring = '1'
			} else {
				if ((this.isAdd === false && this.modifyData.tel === this.ruleForm.phone) || (this.addFlag === true && this.data.tel === this.ruleForm.phone)) {
					this.phoneWaring = ''
				} else {
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlNVA}/verifytelfree/${this.ruleForm.phone}`,
						loading: false
					}).then(res => {
						if (res.result === true) {
							this.phoneWaring = ''
						} else {
							this.phoneWaring = '2'
						}
						this.rulePhone()
					})
				}
			}
		},
		submitForm (formName) {
			this.checkPhone()
			if (this.ruleForm.subscriptionSendFlag && this.ruleForm.subscriptionOpenId === '') {
				this.$message.error('未绑定接收人，无法保存')
				return false
			}
			if (this.ruleForm.autoprint === 1 && this.ruleForm.printname === '') {
				this.$message.error('请选择打印机')
				return false
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.isAdd === true) {
						if (this.addFlag) {
							let params = {
								staffid: this.id,
								staffName: this.ruleForm.name,
								usertype: this.ruleForm.usertype,
								payForCustomerFlag: this.ruleForm.payForCustomerFlag,
								tel: this.ruleForm.phone,
								// password: this.ruleForm.pass,
								staffDisabled: this.ruleForm.status,
								roleIds: this.staffRole,
								subscriptionAppId: this.ruleForm.subscriptionAppId,
								subscriptionNickName: this.ruleForm.subscriptionNickName,
								subscriptionOpenId: this.ruleForm.subscriptionOpenId,
								subscriptionSendFlag: this.ruleForm.subscriptionSendFlag,
								addr: this.ruleForm.addr ? this.ruleForm.addr.replace(/[\r\n\t\\\']/g, '') : '',
								bankName: this.ruleForm.bankName ? this.ruleForm.bankName.replace(/[\r\n\t\\\']/g, '') : '',
								bankAccount: this.ruleForm.bankAccount ? this.ruleForm.bankAccount.replace(/[\r\n\t\\\']/g, '') : '',
								bankcardno: this.ruleForm.bankcardno ? this.ruleForm.bankcardno.replace(/[\r\n\t\\\']/g, '') : '',
								identitycardno: this.ruleForm.identitycardno ? this.ruleForm.identitycardno.replace(/[\r\n\t\\\']/g, '') : '',
								remark: this.ruleForm.remark ? this.ruleForm.remark.replace(/[\r\n\t\\\']/g, '') : '',
								printname: this.ruleForm.printname,
								relAllShopFlag: this.ruleForm.shopattendway,
								sIds: this.chooseShop
							}
							if (psd !== this.ruleForm.pass) {
								params.password = this.ruleForm.pass
							}
							const logger = this.$fxLogger.createInfo('seller.employee-manage.update', this.createLoggerParams())
							this.$store.dispatch('requestPost', {
								url: `${this.$fxBaseApi.urlIV}/account/staff/update`,
								data: params,
								logger
							}).then(res => {
								if (res.result === true) {
									this.showMask = true
									this.getDetail(this.ruleForm.id).then(() => {
										this.getRole(this.ruleForm.id).then(() => {
											this.fxDataVerification.resetData(this.ruleForm)
										})
										// this.fxDataVerification.resetData(this.ruleForm)
									})
									this.$message.success('保存成功！')
									// this.$emit('showModal', false)
								} else {
									this.$message.error(res.msg)
								}
							})
						} else {
							let params = {
								staffName: this.ruleForm.name,
								tel: this.ruleForm.phone,
								usertype: this.ruleForm.usertype,
								payForCustomerFlag: this.ruleForm.payForCustomerFlag,
								// password: this.ruleForm.pass,
								staffDisabled: this.ruleForm.status,
								roleIds: this.staffRole,
								subscriptionSendFlag: this.ruleForm.subscriptionSendFlag,
								addr: this.ruleForm.addr ? this.ruleForm.addr.replace(/[/[\r\n\t\\\']/g, '') : '',
								bankName: this.ruleForm.bankName ? this.ruleForm.bankName.replace(/[/[\r\n\t\\\']/g, '') : '',
								bankAccount: this.ruleForm.bankAccount ? this.ruleForm.bankAccount.replace(/[/[\r\n\t\\\']/g, '') : '',
								bankcardno: this.ruleForm.bankcardno ? this.ruleForm.bankcardno.replace(/[\r\n\t\\\']/g, '') : '',
								identitycardno: this.ruleForm.identitycardno ? this.ruleForm.identitycardno.replace(/[\r\n\t\\\']/g, '') : '',
								remark: this.ruleForm.remark ? this.ruleForm.remark.replace(/[\r\n\t\\\']/g, '') : '',
								autoprintflag: this.ruleForm.autoprint,
								printname: this.ruleForm.printname,
								relAllShopFlag: this.ruleForm.shopattendway,
								sIds: this.chooseShop
							}
							if (psd !== this.ruleForm.pass) {
								params.password = this.ruleForm.pass
							}
							const logger = this.$fxLogger.createInfo('seller.employee-manage.add', { name: params.staffName })
							this.$store.dispatch('requestPost', {
								url: `${this.$fxBaseApi.urlIV}/account/staff/add`,
								data: params,
								logger
							}).then(res => {
								if (res.result === true) {
									this.$message.success('保存成功！')
									this.$emit('getId', res.data.userId)
									this.ruleForm.id = res.data.userId
									this.addFlag = true
									this.isAdd = false
									this.$emit('close', true)
									this.$nextTick(() => {
										// this.getData()
										this.getDetail(this.ruleForm.id).then(() => {
											this.getRole(this.ruleForm.id).then(() => {
												this.fxDataVerification.resetData(this.ruleForm)
											})
											// this.fxDataVerification.resetData(this.ruleForm)
										})
									})
								} else {
									this.$message.error(res.msg)
								}
							})
						}
					} else {
						let params = {
							staffid: this.ruleForm.id,
							staffName: this.ruleForm.name,
							usertype: this.ruleForm.usertype,
							payForCustomerFlag: this.ruleForm.payForCustomerFlag,
							tel: this.ruleForm.phone,
							// password: this.ruleForm.pass,
							staffDisabled: this.ruleForm.status,
							roleIds: this.staffRole,
							subscriptionAppId: this.ruleForm.subscriptionAppId,
							subscriptionNickName: this.ruleForm.subscriptionNickName,
							subscriptionOpenId: this.ruleForm.subscriptionOpenId,
							subscriptionSendFlag: this.ruleForm.subscriptionSendFlag,
							addr: this.ruleForm.addr ? this.ruleForm.addr.replace(/[\r\n\t\\\']/g, '') : '',
							bankName: this.ruleForm.bankName ? this.ruleForm.bankName.replace(/[\r\n\t\\\']/g, '') : '',
							bankAccount: this.ruleForm.bankAccount ? this.ruleForm.bankAccount.replace(/[\r\n\t\\\']/g, '') : '',
							bankcardno: this.ruleForm.bankcardno ? this.ruleForm.bankcardno.replace(/[\r\n\t\\\']/g, '') : '',
							identitycardno: this.ruleForm.identitycardno ? this.ruleForm.identitycardno.replace(/[\r\n\t\\\']/g, '') : '',
							remark: this.ruleForm.remark ? this.ruleForm.remark.replace(/[\r\n\t\\\']/g, '') : '',
							autoprintflag: this.ruleForm.autoprint,
							printname: this.ruleForm.printname,
							relAllShopFlag: this.ruleForm.shopattendway,
							sIds: this.chooseShop
						}
						if (psd !== this.ruleForm.pass) {
							params.password = this.ruleForm.pass
						}
						const logger = this.$fxLogger.createInfo('seller.employee-manage.update', this.createLoggerParams())
						this.$store.dispatch('requestPost', {
							url: `${this.$fxBaseApi.urlIV}/account/staff/update`,
							data: params,
							logger
						}).then(res => {
							if (res.result === true) {
								this.showMask = true
								this.getDetail(this.ruleForm.id).then(() => {
									this.getRole(this.ruleForm.id).then(() => {
										this.fxDataVerification.resetData(this.ruleForm)
									})
									// this.fxDataVerification.resetData(this.ruleForm)
								})
								this.$message.success('保存成功！')
								// this.$emit('showModal', false)
							} else {
								this.$message.error(res.msg)
							}
						})
					}
				}
			})
		},
		resetForm (formName) {
			// console.log(formName, this.$refs[formName], '11111')
			// this.$refs[formName].resetFields()
			this.$emit('close', true)
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			originData.roleName = originData.role
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			// ruleForm.roleName = this.getRoleName(ruleForm.role)
			ruleForm.roleName = this.getRoleName(this.staffRole)
			// console.log(originData.roleName, ruleForm.roleName)
			return {
				pre: originData,
				cur: ruleForm,
				name: ruleForm.name
			}
		},
		getRoleName (id) {
			if (id.length === 0) {
				return ''
			}
			let name = []
			this.roleTableData.forEach(item => {
				if (id.indexOf(item.id) !== -1) {
					name.push(item.name)
				}
			})
			return name.join('/')
			// return (this.roleTableData.find(item => {
			// 	return item.id === id
			// }) || {}).name
		},
		downloadStaffImg () {
			if (!this.ruleForm.id) {
				this.$message.warning('暂无可下载的分销码图片')
				return
			}
			const fileName = `${this.ruleForm.name || '员工'}分销码.png`
			const req = new XMLHttpRequest()
			req.open('POST', `${this.$fxBaseApi.snvUrl}shop/account/staff/promotion/code/download?userId=${this.ruleForm.id}`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = () => {
				if (req.status !== 200 || !req.response || req.response.size === 0) {
					this.$message.error('下载失败')
					return
				}
				const blobUrl = window.URL.createObjectURL(req.response)
				const a = document.createElement('a')
				a.style.display = 'none'
				a.download = fileName
				a.href = blobUrl
				a.click()
				setTimeout(() => {
					window.URL.revokeObjectURL(blobUrl)
				}, 100)
			}
			req.onerror = () => {
				this.$message.error('下载失败')
			}
			req.send()
		}
	}
}
</script>
<style lang="stylus">
.subordinateDialog{
	.el-dialog__body{
		padding :0px 20px;
	}
	.el-dialog__header {
		display :none
	}
	.blue-line{
		height :20px;
		width: 5px;
		background-color :var(--fx-primary-color);
		margin-right :10px;
	}
	.title{
		font-size:16px;
		justify-content: space-between;
		font-weight: bold;
		display :flex;
		flex-direction :row;
		border-bottom:1px solid #eee;
		padding: 20px 0px 10px;
		text-align: left;
		margin-bottom :5px;
		.close{
			cursor: pointer;
			width: 20px;
			height: 20px;
			display :flex;
			align-items :center;
			justify-content :center;
			color :white;
			border-radius: 50%;
			background-color: #f00;
			line-height: 21px;
			font-weight: bold;
		}
	}
}
</style>
<style lang="stylus" scoped>
.time-tip{
	width: 150px;
	margin-left: 95px;
	margin-bottom: 10px;
	color :#f00;
	text-align :center
}
.tip-box{
	display :flex;
	flex-direction :column;
	padding-left 10px;
	box-sizing :border-box;
	text-align :left;
}
.code-box{
	width:150px;
	height:150px;
	position :relative;
	margin-left:95px;
	margin-bottom :10px;
}
.no-follow{
	position :absolute;
	width :100%;
	height :100%;
	background-color :rgba(0,0,0,0.1);
	display:flex;
	align-items :center;
	justify-content :center;
	top:0;
	left:0
}
.subordinateDialog{
	.type-box{
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 30px;
		align-items: center
	}
	.input-box {
		display flex
		width: 400px;
		align-items: center;
		height: 40px;
		span {
			margin-right: 10px
		}
		.name-input {
			flex: 1;
			margin-right :10px
		}
	}
}
.business{
    width :100%;
    height :100%;
    display: flex;
	flex-direction: column;
    .business-body{
        height :380px;
        overflow-y :auto;
        padding-left :20px;
        .basic-info-wrap{
            display :flex;
            flex-direction :row;
            align-items :flex-start;
            .basic-info-left{
                flex :1;
                min-width :0;
            }
        }
        .business-picture{
            flex-shrink :0;
            width :200px;
            margin-right :20px;
            .distribution-code-title{
                text-align :left;
                font-size :14px;
                color :#333;
                margin-bottom :8px;
            }
            .distribution-code-img{
                width :200px;
                height :200px;
                .staff-avatar-img{
                    width :100%;
                    height :100%;
                    object-fit :cover;
                }
            }
            .distribution-code-download{
                margin-top :8px;
                font-size :12px;
                color :var(--fx-primary-color);
                cursor :pointer;
                text-align :center;
            }
        }
        .box{
            width :100%
            .input-box{
                width :250px;
            }
            .el-form-item >>> .el-form-item__content{
                text-align :left
                }
        }
    }
    .business-foot{
        position: relative;
        margin-top :10px;
        width :100%
        .btn{
            width :35%;
			margin-left: 20px;
        }
    }
}
</style>
